import React from 'react';
//Redux
import configureStore from './store/configureStore';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
//styles
import 'react-toastify/dist/ReactToastify.css';
import './App.scss';
//components
import Routes from './routes/Routes';
import { ToastContainer } from 'react-toastify';
import PublicConfigWrapper from './routes/appWrappers/PublicConfigWrapper';
//utils
import { setGlobalParams, normalizeFonts } from 'utils';
export const { store, persistor } = configureStore();

export default class App extends React.Component {
  constructor(props) {
    super(props);
    setGlobalParams(process.env.REACT_APP_HOST_PATH);
  }

  componentDidMount() {
    normalizeFonts();
    window.addEventListener('resize', normalizeFonts);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', normalizeFonts);
  }

  render() {
    return (
      <div className="App">
        <div className={`App__Content`}>
          <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              <PublicConfigWrapper>
                <Routes />
              </PublicConfigWrapper>
              <ToastContainer
                toastClassName="toast-container"
                position="top-center"
                type="default"
                autoClose={2000}
                hideProgressBar={true}
                newestOnTop={false}
                closeOnClick
                pauseOnHover
              />
            </PersistGate>
          </Provider>
        </div>
      </div>
    );
  }
}
